import { useEffect, useState } from "react";

/**
 * Listens to a media query and returns whether it currently matches.
 * Rerenders when the match state changes.
 *
 *   const isMobile = useMediaQuery("(max-width: 767px)");
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

/** Tailwind `md` breakpoint matches — our main mobile vs desktop gate. */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
